import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { useSelector, useDispatch } from "react-redux";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CustomSelectMulti from "../../../../../../Components/CustomSelectMulti";
import { useLocation } from "react-router-dom";
import {
  createFeedback,
  updateFeedback,
} from "../Feedback/store/FeedbackService";
import DataService from "../../../../../../Service";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "none",
  },
  dialog_title: {
    marginLeft: "1.5rem",
    "& h6": {
      fontWeight: "700",
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "94%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #077F83",
    },
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "13px",
      color: "#303030",
    },
    "& svg": {
      width: "1.2em",
      height: "1.2em",
    },
  },
  inputLabel: {
    top: "50%",
    left: "10px",
    transform: "translate(0, -50%)",
  },
}));

interface IProps {
  isOpen: any;
  onClose(): void;
  props: any;
  pageData: any;
  onCreate: any;
  currentSelection: any;
  assignmentId: any;
}

interface IRadioButtonState {
  other_stakeholders: any;
  acuity_admin: any;
}

const FeedbackModal: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const { isOpen, onClose, currentSelection, assignmentId } = props;
  const dispatch = useDispatch();
  const location: any = useLocation();
  const feedbackData = useSelector((state: any) => state?.feedback);
  const [givenToArray, setGivenToArray] = useState<any>([]);
  // const givenToArray = ["one", "two", "three"].map((data: any) => { return { "id": data, "value": data, "name": data } })

  const [radioButtonValue, setRadioButtonValue] = useState<any>({});
  const [users, setUsers] = useState<any>([]);
  const [multiSelect, setMultiSelect] = useState<any>([]);
  const [givenToArrayMulitSelect, setGivenToArrayMulitSelect] = useState<any>(
    []
  );
  const [textAreaValue, setTextAreaValue] = useState<any>("");
  const [selectedValue, setSelectedValue] = useState<any>(undefined);
  const [submitClickFlag, setSubmitClickFlag] = useState<boolean>(false);

  const handleChangeRadioValue = (event: any) => {
    const { name, value } = event.target;
    setRadioButtonValue({ [name]: value });
  };

  const handleChangeTextArea = (event: any) => {
    const { name, value } = event.target;
    setTextAreaValue({ [name]: value });
  };

  const handleChangeSelectDropdownValue = (event: any) => {
    const { name, value } = event.target;
    setSelectedValue({ [name]: value });
  };

  useEffect(() => {
    if (
      radioButtonValue?.other_stakeholders ||
      currentSelection?.other_stakeholders
    ) {
      feedbackData?.dropDownlist?.employees?.map((data: any) => {
        return (data["value"] = data?.name);
      });
      setUsers(feedbackData?.dropDownlist?.employees);
    }
  }, [dispatch, radioButtonValue, currentSelection?.other_stakeholders]);
  const handleSubmit = (e: any) => {
    e.preventDefault();

    let arrayData: any = [];
    let givenToArrayData: any = [];
    var formData: any = new FormData();
    
    multiSelect?.map((data: any) => {
      arrayData.push(data?.id);
    });
    givenToArrayMulitSelect.map((arr: any) => {
      givenToArrayData.push(arr.value);
    });
    formData.append("assignment_id", location?.state?.currentAssignment?.id);
    formData.append("organisation_id", props?.pageData?.organisation_id);
    formData.append(
      "other_stakeholders",
      Boolean(radioButtonValue?.other_stakeholders)
    );
    formData.append("acuity_admin", Boolean(radioButtonValue?.acuity_admin));
    formData.append("feedback",textAreaValue?.feedback ?(textAreaValue?.feedback):"");
    formData.append("session_scenario_id", selectedValue?.session_scenario_id);
    formData.append("feedback_given_by", JSON.stringify(arrayData));
    formData.append("given_to", givenToArrayData);
    
    console.log("given", givenToArrayMulitSelect, multiSelect,formData,textAreaValue);
    const param = location?.state?.currentAssignment?.id;
    if (!currentSelection?.id) {
      dispatch(
        createFeedback(
          formData,
          (): any => {
            onClose();
            props.onCreate();
          },
          param
        )
      );
    } else {
      formData.append("feedback_id", currentSelection?.id);
      dispatch(
        updateFeedback(formData, (): any => {
          onClose();
          props.onCreate();
        })
      );
    }
  };

  const getCoachList = () => {
    DataService.getDirectData("shortlisting_coaches/fetch_chemistry_coaches", {
      assignment_id: assignmentId,
    }).then((res) => {
      console.log(res,"coach given")
    const arr=  res.chemistry_coaches.map((coach: any) => {
        console.log(coach,"coach given",res)
        return {
          id: coach.coach_id,
          value: coach.coach_name,
          name: coach.coach_name,
        };
      })
      setGivenToArray([...arr,{id:100,value:"Acuity admin",name:"Acuity admin"}]);
      
    });
  };

  useEffect(() => {
    getCoachList();
  }, []);

  useEffect(() => {
    if (currentSelection) {
      const selectedUserValue = users.filter((item: any) =>
        currentSelection?.employee_name.includes(item.value)
      );
      setMultiSelect(selectedUserValue);
      const selectedGivenToValue = givenToArray?.filter((item: any) =>
        currentSelection?.given_to?.split(",").includes(item.value)
      );
      setGivenToArrayMulitSelect(selectedGivenToValue);
      setTextAreaValue({ feedback: currentSelection?.feedback });
      setSelectedValue({
        session_scenario_id: currentSelection?.session_scenario_id,
      });
      setRadioButtonValue({
        acuity_admin: currentSelection?.acuity_admin ? "Acuity admin" : "",
        other_stakeholders: currentSelection?.other_stakeholders
          ? "Other stakeholders"
          : "",
      });
    }
  }, [currentSelection, users, givenToArray]);
  return (
    <>
      <Dialog
        maxWidth={"sm"}
        fullWidth={true}
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        >
          Add feedback
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>
          <div className={classes.formWrapper}>
            <form spellCheck="false" onSubmit={handleSubmit}>
              <div>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Given by
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid xs={12}>
                      <RadioGroup
                        // value={coachingDimensionValue}
                        defaultValue={
                          currentSelection?.acuity_admin
                            ? "Acuity admin"
                            : currentSelection?.other_stakeholders
                            ? "Other stakeholders"
                            : ""
                        }
                        onChange={handleChangeRadioValue}
                      >
                        <Grid container spacing={1} direction="row">
                          <Grid xs={6}>
                            <FormControlLabel
                              // checked={radioButtonValue?.other_stakeholders}
                              value="Other stakeholders"
                              id="other_stakeholders"
                              name="other_stakeholders"
                              control={<Radio color="primary" />}
                              label="Stakeholders"
                              className={classes.paper}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <FormControlLabel
                              // checked={radioButtonValue?.acuity_admin}
                              id="acuity_admin"
                              name="acuity_admin"
                              value="Acuity admin"
                              control={<Radio color="primary" />}
                              label="Acuity admin"
                              className={classes.paper}
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </Grid>
                  </Grid>

                  <Grid item xs={3}></Grid>
                  <Grid item xs={9}>
                    <Grid xs={12}>
                      {radioButtonValue.other_stakeholders ==
                      "Other stakeholders" ? (
                        <>
                          <FormControl
                            style={{ width: "100%" }}
                            variant="outlined"
                          >
                            <CustomSelectMulti
                              id="feedback_given_by"
                              name="feedback_given_by"
                              itemArr={users}
                              value={multiSelect}
                              parentcall={(e: any) => {
                                setMultiSelect(e);
                              }}
                              placeholder="Search by name or email"
                            />
                          </FormControl>
                        </>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Given to
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <FormControl variant="outlined">
                        <CustomSelectMulti
                          id="given_to"
                          name="given_to"
                          itemArr={givenToArray}
                          value={givenToArrayMulitSelect}
                          parentcall={(e: any) => {
                            setGivenToArrayMulitSelect(e);
                          }}
                          placeholder="Search by name or email"
                        />
                      </FormControl>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Session scenario
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl
                      style={{ width: "100%", zIndex: 0 }}
                      variant="outlined"
                    >
                      <FormControl variant="outlined">
                        {!currentSelection?.session_scenario_id ? (
                          <InputLabel
                            className={classes.inputLabel}
                            id="session_scenario_id"
                            shrink={false}
                          >
                            {!selectedValue?.session_scenario_id &&
                              "Session scenario"}
                          </InputLabel>
                        ) : null}
                        <Select
                          labelId="session_scenario_id"
                          id="session_scenario_id"
                          name={"session_scenario_id"}
                          defaultValue={currentSelection?.session_scenario_id}
                          onChange={handleChangeSelectDropdownValue}
                        >
                          <MenuItem value="">
                            <span
                              style={{ color: "#808080", display: "block" }}
                            >
                              Session scenario
                            </span>
                          </MenuItem>
                          {feedbackData?.dropDownlist?.session_scenario?.map(
                            (data: any, index: number) => {
                              return (
                                <MenuItem key={index} value={data?.id}>
                                  {data?.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      </FormControl>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  justify={"flex-start"}
                  style={{ marginBottom: 10 }}
                >
                  <Grid item xs={3} alignItems={"flex-start"}>
                    <Typography variant="h2" className={classes.title}>
                      Feedback
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <TextareaAutosize
                        aria-label="minimum height"
                        name={`feedback`}
                        rowsMin={8}
                        className={classes.textAreaEmpty}
                        onChange={handleChangeTextArea}
                        value={textAreaValue?.feedback}
                        placeholder="Feedback"
                      />
                      {submitClickFlag && !textAreaValue?.feedback ? (
                        <FormHelperText style={{ color: "red" }}>
                          Please enter the feedback
                        </FormHelperText>
                      ) : (
                        <></>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-end"}
                  style={{ marginTop: 20 }}
                >
                  <Grid item xs={2} style={{ marginRight: "1rem" }}>
                    <Button
                      disableElevation
                      type="button"
                      style={{ textTransform: "capitalize" }}
                      onClick={() => {
                        onClose();
                      }}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      disableElevation
                      type="submit"
                      style={{ textTransform: "none" }}
                      variant={"contained"}
                      color="secondary"
                    >
                      {currentSelection?.id ? "Edit" : "Add"}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FeedbackModal;
